import { Menu } from '@mantine/core';
import { useMemo, useState } from 'react';
import { useGetLanguageInfo } from '@mygpt/app';
import { SvgLanguage } from './icon';

export default () => {
  const { langSelected, languageOnChange, languageOptions } = useGetLanguageInfo();

  const [value, setValue] = useState(langSelected?.value);

  const language = useMemo(() => {
    const target = languageOptions.find((item) => item.value === value);
    return target ? target.label : '';
  }, [value]);

  return (
    <Menu trigger="hover" position="top-end">
      <Menu.Target>
        <div className="flex items-center cursor-pointer">
          <div className="rounded-full border border-[#E0E5F2] flex-shrink-0 p-[7px] mr-2">
            <SvgLanguage />
          </div>
          {language}
        </div>
      </Menu.Target>

      <Menu.Dropdown>
        {languageOptions.map((item) => {
          return (
            <Menu.Item
              key={Math.random()}
              onClick={() => {
                setValue(item.value);
                languageOnChange(item.value);
              }}
            >
              {item.label}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  );
};
